import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DictionaryService } from './dictionary.service';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
  providedIn: 'root'
})
export class RuleService
{
  constructor(
    private http: HttpClient,
    private dictionaryService: DictionaryService) { }

  /**
   * Convert recursively Query Rules value property from Array to String.
   *
   * @param rule Query Rules object
   */
  public convertRulesValueArrayToString(rule: any): void
  {
    rule.rules.forEach(r =>
    {
      if ((r.operator === 'in') || (r.operator === 'not in'))
      {
        r.value = r.value.toString();
      }
      else if (r.rules)
      {
        this.convertRulesValueArrayToString(r);
      }
    });
  }

  /**
   * Convert recursively Query Rules date time value property from local date/time to UTC date/time String.
   *
   * @param rule Query Rules object
   */
  public convertRulesValueDateTimeToUTC(rule: any): void 
  {
    rule.rules.forEach(r =>
    {
      if (r.value && r.value[4] === '-' && r.value[7] === '-' && r.value[10] === 'T')
      {
        r.value = new Date(`${r.value}`).toISOString();
      }
      else if (r.rules)
      {
        this.convertRulesValueDateTimeToUTC(r);
      }
    });
  }

  /**
   * Convert recursively Query Rules value property from String to Array.
   *
   * @param rule Query Rules object
   */
  public convertRulesValueStringToArray(rule: any): void
  {
    rule.rules.forEach(r =>
    {
      if ((r.operator === 'in') || (r.operator === 'not in'))
      {
        r.value = r.value.split(',');
      }
      else if (r.rules)
      {
        this.convertRulesValueStringToArray(r);
      }
    });
  }

  /**
   * Convert recursively Query Rules date time value property from UTC date/time to local date/time String.
   *
   * @param rule Query Rules object
   */
  public convertRulesValueDateTimeToLocal(rule: any): void
  {
    rule.rules.forEach(r =>
    {
      if (r.value && r.value[4] === '-' && r.value[7] === '-' && r.value[10] === 'T')
      {
        r.value = this.convertUTCDateToLocalDate(new Date(r.value)).toISOString().replace('Z', '');
      }
      else if (r.rules)
      {
        this.convertRulesValueDateTimeToLocal(r);
      }
    });
  }

  /**
   * Get query rules for a Channel.
   *
   * @param id Channel ID
   */
  public getQueryRuleByChannel(channelId: number, ruleSetId: number): any
  {
    return this.http.get<any>(`/channels/${channelId}/ruleset/${ruleSetId}/queryRules`);
  }

  /**
   * Persists a query rule in the database.
   *
   * @param rule Query rule to save
   * @param isNew Is this a new query rule?
   */
  public saveQueryRule(rule: any, isNew: boolean): any
  {
    if (isNew)
    {
      return this.http.post('/channels/queryRule', rule);
    }
    else
    {
      return this.http.put('/channels/queryRule', rule);
    }
  }

  public convertUTCDateToLocalDate(date: Date)
  {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }

  public getFormlyFieldDictionaries(fields: FormlyFieldConfig[]): any []
  {
    let dictionaryObservables: any = [];
    fields.forEach(d =>
    {
      if (d.type !== undefined)
      {
        if (d.type === 'tabs' && d.fieldGroup) 
        {
          d.fieldGroup.forEach((tabGroup) =>
          {
            if (tabGroup.fieldGroup) { tabGroup.fieldGroup.forEach((fieldGroup) => { dictionaryObservables = this.processFormlyFieldDictionaries(fieldGroup, dictionaryObservables); }); }
          });
        }
        else 
        {
          dictionaryObservables = this.processFormlyFieldDictionaries(d, dictionaryObservables);
        }
      }
    });
    return dictionaryObservables;
  }

  /**
   * Locate all dictionaries that are included in the Assessment fields
   * 
   * @param d Assessment data
   * @param dictionaries Dictionaries
   * @returns Array of dictionaries
   */
  private processFormlyFieldDictionaries(d: any, dictionaries: any[]): any[] 
  {
    if ((d.type === 'select' || d.type === 'multiselect') && d.templateOptions && d.templateOptions.codeSetId) 
    {
      dictionaries.push(this.dictionaryService.getCachedCodesByCodeSetId(d.templateOptions.codeSetId));
    }
    return dictionaries;
  }

}
